import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import { cuentaBancaria } from '../../../models/cuentaBancaria';
import { modalComponent } from '../../../utils/modal/modal.component';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'cuentaBancaria-consultar',
    styleUrls: [], 
    templateUrl: 'cuentaBancaria-consultar.component.html',
    providers: [generalService]
})

export class CuentaBancariaConsultarComponent implements OnInit{

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: DataSourceGrid | null;
    displayedColumns = ['acciones', 'NAME','BANK_NAME','CLABE','ACCOUNT_NAME','HOLDER','ACCCOUNT_NUMBER','CARD_NUMBER'];
    public datosCuentaBancaria: any[] = [];;

    public dataconciliacion:any;

    // Modal messages
    private readonly CONFIRM_DELETE_MSG = '¿Está seguro dar de baja la cuenta?';

    constructor(private _generalService: generalService, 
      public dataService: DataService, 
      public dialog: MatDialog,
      public _activated : ActivatedRoute) {this.dataconciliacion = new Array();
    }

    ngOnInit() {
      this.consultarCuentaBancaria();
    }

    consultarCuentaBancaria(){
      let metodo = 'cuentaBancaria/consultarCuentaBancaria';
      const params = { 
        loacs: sessionStorage.getItem('acslo')  
      };      this._generalService.metodoCallParams(params, metodo, true).subscribe(
        result => {
          this.datosCuentaBancaria = JSON.parse(result);
          
         this.dataSource = new DataSourceGrid(this.datosCuentaBancaria, this.paginator, this.sort);
          // console.log(this.datosCuentaBancaria);
          
        },
        error => {  console.log(<any>error);  }
      );
    }

    searchFilter(searchTerm: string) {
      if(this.datosCuentaBancaria.length <= 0) {
        this.dataSource = undefined;
      } else {
        let filtroVehiculos = this.datosCuentaBancaria;
        if(searchTerm != "") {
          filtroVehiculos = this.datosCuentaBancaria.filter((obj: any) => {            
            if (obj.NAME.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 
            || obj.BANK_NAME.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 
            )
                return true;
            else
                return false;
          });
        }
        this.dataSource = new DataSourceGrid(filtroVehiculos, this.paginator, this.sort);
      }
    }

    confirmDeleteCuentaBancaria(data: cuentaBancaria) {
      this.dataService.modal = 'confirm';
      this.dataService.mensaje = this.CONFIRM_DELETE_MSG;
    
      const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
      this.dataService.dialogRef = dialogModal;
      this.dataconciliacion = data;
    
      dialogModal.afterClosed().subscribe(result => {
        if (this.dataService.guardado) {
          this.deleterow(this.dataconciliacion);
        }
      });
    }

    deleterow(data: any) {
      const params = { 
        loacs: sessionStorage.getItem('acslo'),
        BANK_ACCOUNT_ID:data.BANK_ACCOUNT_ID
      };
      this._generalService.metodoCallParams(params, `cuentaBancaria/deleteCuentaBancaria`)
      .subscribe(ok => {
          
          this.consultarCuentaBancaria();
          
          setTimeout(() => {
              this._generalService.toastCall("La cuenta se dio de baja exitosamente");
            }, 500); 
      }, error => {
        // Custom error handler
      }); 
    }

}


// WEBPACK FOOTER //
// ./src/app/Contabilidad/cuentaBancaria/consultar-eliminar/cuentaBancaria-consultar.component.ts